import { render, staticRenderFns } from "./PaymentMethodCreate.vue?vue&type=template&id=3ec57c34&scoped=true&"
import script from "./PaymentMethodCreate.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec57c34",
  null
  
)

export default component.exports